import { reactToCwp } from '@ampdx/common-utils/src/react-utils.jsx'
import { Tabs } from './Tabs.tsx'

export default reactToCwp(Tabs)
